export default __webpack_public_path__ + "static/BlinkFitness_Balanced-cff25ec7a2339cee212288be32ca32a1.ttf";